import { useEffect, useRef } from 'react';

export type TPageLeaveHandler = () => void;
export type TPageLeaveEventType = 'beforeunload' | 'pagehide' | 'visibilitychange';

// WARNING: 'beforeunload' event triggers on closing page AND on reloading too !
export const EVENT_TYPES: TPageLeaveEventType[] = ['visibilitychange', 'pagehide', 'beforeunload'];
export const DEFAULT_EVENT: TPageLeaveEventType = 'beforeunload';

const useOnPageLeave = (handler: TPageLeaveHandler, eventType?: TPageLeaveEventType): void => {
  const handlerRef = useRef<TPageLeaveHandler>();
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const event = eventType && EVENT_TYPES.includes(eventType) ? eventType : DEFAULT_EVENT;
    const isVisibilityEvent = event === 'visibilitychange';
    const target = isVisibilityEvent ? document : window;
    const listener = () => {
      if (!isVisibilityEvent || document.visibilityState === 'hidden') {
        handlerRef.current?.();
      }
    };
    target.addEventListener(event, listener);
    return () => {
      target.removeEventListener(event, listener);
    };
  }, []);
};

export default useOnPageLeave;
